module.exports = __webpack_public_path__ + "img/workflow-icon.7d78a0a9.svg";